module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payZFBTipsSuc-sec"
  }, [_vm._v("\n\t请返回微信商城查看详情\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8545014a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/payZFBTips.vue
// module id = 582
// module chunks = 1